import { useFormikContext } from "formik";
import { useEffect } from "react";

export const FormikDisabler = ({ disabled }) => {
  const { setSubmitting, isSubmitting, initialValues } = useFormikContext();
  useEffect(() => {
    if (disabled) {
      setSubmitting(true);
    } else {
      setSubmitting(false);
    }
  }, [disabled, setSubmitting, isSubmitting, initialValues]);
  return null;
};
